import type { ReactNode } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@admin/components/ui/card";

export type SignupMetadata = {
  signupIp: string | null;
  signupCountry: string | null;
  signupGeo: Record<string, string | undefined> | null;
  signupClient: Record<string, string | number | undefined> | null;
};

function Row({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div className="flex flex-wrap gap-2">
      <span className="w-40 shrink-0 text-muted-fg">{label}</span>
      <span className="min-w-0 flex-1 break-all">{value}</span>
    </div>
  );
}

export function SignupContextSection({ metadata }: { metadata: SignupMetadata }) {
  const { signupIp, signupCountry, signupGeo, signupClient } = metadata;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Signup context</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2 text-sm">
        <Row label="IP" value={signupIp ?? "-"} />
        <Row label="Country" value={signupCountry ?? "-"} />
        <Row label="City" value={signupGeo?.city ?? "-"} />
        <Row
          label="Timezone (browser)"
          value={String(signupClient?.browserTimezone ?? "-")}
        />
        <Row label="Timezone (IP geo)" value={signupGeo?.timezone ?? "-"} />
        <Row
          label="Screen"
          value={
            signupClient?.screenWidth && signupClient?.screenHeight
              ? `${signupClient.screenWidth}x${signupClient.screenHeight}`
              : "-"
          }
        />
        <Row label="Accept-Language" value={String(signupClient?.acceptLanguage ?? "-")} />
        <Row label="User-Agent" value={String(signupClient?.userAgent ?? "-")} />
        <Row label="Referer" value={String(signupClient?.referer ?? "-")} />
        {signupGeo && Object.keys(signupGeo).length > 0 && (
          <Row
            label="Geo (raw)"
            value={
              <pre className="whitespace-pre-wrap text-xs">
                {JSON.stringify(signupGeo, null, 2)}
              </pre>
            }
          />
        )}
        {signupClient && Object.keys(signupClient).length > 0 && (
          <Row
            label="Client (raw)"
            value={
              <pre className="whitespace-pre-wrap text-xs">
                {JSON.stringify(signupClient, null, 2)}
              </pre>
            }
          />
        )}
      </CardContent>
    </Card>
  );
}
